// extracted by mini-css-extract-plugin
module.exports = {"custom-placeholder":"CustomDatePicker_custom-placeholder__ZYPZy","custom-placeholder-icon":"CustomDatePicker_custom-placeholder-icon__VMK_X"};